import classes from "./SelectAddLang.module.scss";
import { useDispatch, useSelector } from "react-redux";
import CardTouch from "../../../../UI/Card/CardTouch/CardTouch";
import TenUsers from "./../../../../../assets/images/10_users.svg";
import enUs from "./../../../../../assets/images/flags/en_us_rounded.svg";
import ptEu from "./../../../../../assets/images/flags/pt-eu_rounded.svg";
import esEs from "./../../../../../assets/images/flags/es-es_rounded.svg";
import { use } from "i18next";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SystemContext from "../../../../../context/SystemContext";
import { useContext } from "react";

const SelectAddLang = ({ session, Products }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const gameNumbersInSpanish = 15;
  const gameNumbersInEnglish = 17;
  const gameNumbersInEuropeanPortuguese = 16;
  const { changePropertyUrl } = useContext(SystemContext);


  const PriceMonthlyLang = (id) => {
    const PlanValue = Products.periodicity.filter(
      (item) => item.id === id && item.periodicity === "monthly"
    );
    return PlanValue[0].price.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  };
  const map_langs={
    "esEs": "es-es",
    "enUs": "en-us",
    "ptEu": "pt-eu"
  }
  const SelectAddLang = (lang) => {
    changePropertyUrl("/comprar/turbinar/idiomas/"+map_langs[lang])
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChooseAdd",
        step: "MyAddPurchase",
      },
      PostData: {
        sub: session.sub,
        product_id: lang === "esEs" ? [4] : lang === "enUs" ? [3] : [10],
        email: session.email,
      },
      planInfo: {
        value:
          lang === "esEs"
            ? PriceMonthlyLang(4)
            : lang === "enUs"
              ? PriceMonthlyLang(3)
              : PriceMonthlyLang(10),
      },
    });
  };

  return (
    <div className={classes.Card}>
      <CardTouch
        data-testid="boostSubscription_languages_spanishPackCard_btn"
        onClick={() =>
          !session.permissions.game.includes("es-ES") && SelectAddLang("esEs")
        }
        classPrimary={classes.CardLanguage}
      >
        <img className={classes.Image} src={esEs} alt="" />
        <div data-testid="boostSubscription_languages_spanishPack_text" className={classes.Package}>{t("purchase.game_pack_in_spanish")}</div>
        <div className={classes.AddPrice}>{`${gameNumbersInSpanish} ${t("global.games")}: ${PriceMonthlyLang(4)} / mês`}</div>
        {session.permissions.game.includes("es-ES") ? (
          <div data-testid="boostSubscription_languages_ownedSpanishPack_text" className={classes.BtnHasPlan}>{t("purchase.you_already_own_the_item")}</div>
        ) : (
          <div data-testid="boostSubscription_languages_addSpanishPack_text" className={classes.Top}>{t("purchase.add")}</div>
        )}
      </CardTouch>
      <CardTouch
        data-testid="boostSubscription_languages_englishPackCard_btn"
        onClick={() =>
          !session.permissions.game.includes("en-US") && SelectAddLang("enUs")
        }
        classPrimary={classes.CardLanguage}
      >
        <img className={classes.Image} src={enUs} alt="" />
        <div data-testid="boostSubscription_languages_englishPack_text" className={classes.Package}>{t("purchase.game_pack_in_english")}</div>
        <div className={classes.AddPrice}>{`${gameNumbersInEnglish} ${t("global.games")}: ${PriceMonthlyLang(3)} / mês`}</div>
        {session.permissions.game.includes("en-US") ? (
          <div data-testid="boostSubscription_languages_ownedEnglishPack_text" className={classes.BtnHasPlan}>{t("purchase.you_already_own_the_item")}</div>
        ) : (
          <div data-testid="boostSubscription_languages_addEnglishPack_text" className={classes.Top}>{t("purchase.add")}</div>
        )}
      </CardTouch>
      <CardTouch
        data-testid="boostSubscription_languages_portuguesePackCard_btn"
        onClick={() =>
          !session.permissions.game.includes("pt-eu") && SelectAddLang("ptEu")
        }
        classPrimary={classes.CardLanguage}
      >
        <img className={classes.Image} src={ptEu} alt="" />
        <div data-testid="boostSubscription_languages_portuguesePack_text" className={classes.Package}>
          {t("purchase.game_pack_in_european_portuguese")}
        </div>
        <div className={classes.AddPrice}>{`${gameNumbersInEuropeanPortuguese} ${t("global.games")}: ${PriceMonthlyLang(10)} / mês`}</div>
        {session.permissions.game.includes("pt-eu") ? (
          <div data-testid="boostSubscription_languages_ownedPortuguesePack_text" className={classes.BtnHasPlan}>{t("purchase.you_already_own_the_item")}</div>
        ) : (
          <div data-testid="boostSubscription_languages_addPortuguesePack_text" className={classes.Top}>{t("purchase.add")}</div>
        )}
      </CardTouch>
    </div>
  );
};
export default SelectAddLang;
